import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getMobileLink } from '~/src/helpers/mobile';
import { MOBILE_OS } from '~/src/constants';

import {
    BannerContainer,
    BannerInfo,
    BannerTitle,
    BannerDesc,
    BannerButtons,
    MobileButton,
    BannerImages,
    BannerImageItem
} from './style';

class Banner extends Component {

    onClickHandler = (mobileOs, e) => {
        e.preventDefault();
        const { accessToken, refreshToken, agreement, city } = this.props;
        window.location = getMobileLink(accessToken, refreshToken, agreement, city, mobileOs);
    };

    render() {
        const { title, description, background, backgroundVector } = this.props;
        return (
            <BannerContainer
                background={background}
                backgroundVector={backgroundVector}>
                <BannerInfo>
                    <BannerTitle as='h1'>{ title }</BannerTitle>
                    <BannerDesc as='p'>{ description }</BannerDesc>
                    <BannerButtons>
                        <MobileButton onClick={(e) => this.onClickHandler(MOBILE_OS.iphone, e)} store='AppStore' color='#fff' />
                        <MobileButton onClick={(e) => this.onClickHandler(MOBILE_OS.android, e)} store='GooglePlay' color='#fff' />
                    </BannerButtons>
                </BannerInfo>
                <BannerImages>
                    <BannerImageItem src='../static/images/agent/002-Recovered.png' alt='Мобильный телефон'/>
                    <BannerImageItem src='../static/images/agent/001-Recovered.png' alt='Мобильный телефон'/>
                </BannerImages>
            </ BannerContainer>
        );
    }
}

const mapStateToProps = (state) => ({
    accessToken: state.auth.accessToken,
    refreshToken: state.auth.refreshToken,
    agreement: state.auth.clientPersonal?.agreement,
    city: state.city.currentCity,
});

export default connect(
    mapStateToProps,
)(Banner);
